lmApp
  .service('ShowcaseService', ['$rootScope', '$q', '$interval', '$timeout', 'AssetService', 'ToastService',
    function ($rootScope, $q, $interval, $timeout, AssetService, ToastService) {

      var service = {};

      var _parseWidgetType = function (type) {

        switch (type) {
          case 'stockweb/asset':
            return 'asset';

          case 'stockweb/external':
            return 'external';

          case 'stockmob/asset':
            return 'asset';

          case 'stockmob/logo':
            return 'ui:logo';

          case 'stockmob/ui/settings':
            return 'ui:settings';

          case 'stockmob/ui/favorites':
            return 'ui:favorites';

          case 'stockmob/ui/search':
            return 'ui:search';

          case 'stockmob/ui/epg':
            return 'ui:epg';

          case 'stockmob/ui/rdvr':
            return 'ui:rdvr';

          case 'stockmob/back':
            return 'ui:back';

          case 'stockmob/ui/showcase':
            return 'ui:showcase';

          case 'stockmob/ui/recent':
            return 'ui:recent';

          case 'stockmob/ui/asset/collection':
            return 'asset:collection';

          case 'stockmob/external/app':
            return 'external:mobapp';

          case 'stockmob/nop':
            return 'nop';

          case 'stockmob/external':
            return 'external:url';

          default:
            return type;
        }
      };

      service._getWidgetIcon = function (type) {
        switch (type) {
          case 'stockweb/asset':
            return 'mdi-filmstrip';

          case 'stockweb/external':
            return 'mdi-link-variant';

          case 'stockmob/asset':
            return 'mdi-filmstrip';

          case 'stockmob/logo':
            return 'mdi-file-image-box';

          case 'stockmob/ui/settings':
            return 'mdi-settings';

          case 'stockmob/ui/favorites':
            return 'mdi-heart';

          case 'stockmob/ui/search':
            return 'mdi-magnify';

          case 'stockmob/ui/epg':
            return 'mdi-view-list';

          case 'stockmob/ui/rdvr':
            return 'mdi-play-circle';

          case 'stockmob/back':
            return 'mdi-keyboard-backspace';

          case 'stockmob/ui/showcase':
            return 'mdi-view-dashboard';

          case 'stockmob/ui/asset/collection':
            return 'mdi-layers';

          case 'stockmob/external/app':
            return 'mdi-exit-to-app';

          case 'stockmob/ui/recent':
            return 'mdi-history';

          case 'stockmob/external':
            return 'mdi-open-in-app';

          case 'stockmob/nop':
            return 'mdi-image-area';

          default:
            return type;
        }
      };

      service._getWidgetName = function (type) {
        switch (type) {
          case 'stockweb/asset':
            return 'Content';

          case 'stockweb/external':
            return 'External Link';

          case 'stockmob/asset':
            return 'Content';

          case 'stockmob/logo':
            return 'Logo';

          case 'stockmob/ui/settings':
            return 'Settings';

          case 'stockmob/ui/favorites':
            return 'Favorites';

          case 'stockmob/ui/search':
            return 'Search';

          case 'stockmob/ui/epg':
            return 'TV-Guide';

          case 'stockmob/ui/rdvr':
            return 'RDVR';

          case 'stockmob/ui/recent':
            return 'Recent';

          case 'stockmob/external':
            return 'External URL';

          case 'stockmob/back':
            return 'Back';

          case 'stockmob/ui/showcase':
            return 'Showcase';

          case 'stockmob/ui/asset/collection':
            return 'Collection';

          case 'stockmob/external/app':
            return 'External App';

          case 'stockmob/nop':
            return 'Picture';

          default:
            return type;
        }
      };

      var _parseResource = function (resource) {
        var parsed = {};
        var args = resource.split('?');

        if (args.length < 2) return parsed;

        args = args[1].split('&');

        if (args.length < 1) return parsed;

        args.forEach(function (arg) {
          parsed[arg.split('=')[0]] = arg.split('=')[1];
        });

        return parsed;
      };

      service._AllShowGenresValues = [
        {
          title: 'Disabled',
          desc: 'Disabled',
          id: 'disabled'
        }, {
          title: 'Screen',
          desc: 'Full screen genres table',
          id: 'screen'
        }, {
          title: 'Switchers',
          desc: 'Use switchers',
          id: 'switchers'
        }
      ];

      service._AllAndroidAppValues = [
        {
          title: 'Google Play Movies',
          desc: 'Google Play Movies',
          id: 'google play movies'
        }
      ];

      service._AlliOSAppValues = [
        {
          title: 'iTunes',
          desc: 'iTunes',
          id: 'itunes movies'
        }
      ];

      service._AllAppValues = [
        {
          title: 'Google Play Movies',
          desc: 'Google Play Movies',
          id: 'google play movies'
        },
        {
          title: 'iTunes',
          desc: 'iTunes',
          id: 'itunes movies'
        }
      ];

      service._AllSortValues = [
        {
          title: 'By channel LCN',
          desc: 'Sort by LCN',
          id: 'er_lcn'
        }, {
          title: 'New',
          desc: 'Sort by update date',
          id: 'new'
        }
      ];

      service._AllViews = [{
        id: 'live',
        title: 'Live'
      }, {
        id: 'vod',
        title: 'VOD'
      }];

      var _getValues = function (value, type) {
        if (type === 'genres_filter_show_mode') {
          return _.find(service._AllShowGenresValues, {id: value});
        }

        if (type === 'sort') {
          return _.find(service._AllSortValues, {id: value});
        }

        if (type === 'view') {
          return _.find(service._AllViews, {id: value});
        }
      };

      service._ParseWidget = function (item) {
        if (!item) return;

        item._PrivateData = {};

        if (!item.widget_attrs) {
          console.warn('Wrong tile scheme. Breaking parse.');
          return;
        }

        item._PrivateData.title = item.title;
        item._PrivateData.widget_type = _parseWidgetType(item.widget_type);
        item._PrivateData.icon = service._getWidgetIcon(item.widget_type);

        if (item.isDefaultDefined) {
          item._PrivateData.picture = item.picture;
          item._PrivateData.originPicture = item.picture;
        } else if (item.picture) {
          lh.common.resources.getPictureByCategory([
            {
              url: item.picture[0][1].split('?')[0],
              resource_group_id: parseInt(_parseResource(item.picture[0][1])['resource_group_id'], 10),
              type: 'picture'
            }
          ])
            .then(function (response) {
              $timeout(function () {
                item._PrivateData.picture = response;
                item._PrivateData.originPicture = response;
              });
            }, function (reason) {
              item._PrivateData.picture = '';
              item._PrivateData.originPicture = '';
            });
        } else {
          item._PrivateData.picture = '';
          item._PrivateData.originPicture = '';
        }

        switch (item._PrivateData.widget_type) {
          case 'asset':
            AssetService.GetAssetByExtId(item.widget_attrs.asset)
              .then(function (collection) {
                if (collection.length) {
                  item._PrivateData.asset = collection[0];
                  item._PrivateData.asset.genres = collection[0].genres.map(function (genre) {
                    return genre.title;
                  });

                  item._PrivateData.asset.duration /= 60;
                } else {
                  item._PrivateData.asset = {};
                }
              })
              .catch(function () {
                item._PrivateData.asset = {};
              });

            item._PrivateData.text = item.widget_attrs.text || '';
            item._PrivateData.uiTitle = item.widget_attrs.title || '';
            item._PrivateData.searchResult = [];
            item._PrivateData.keyword = '';
            item._PrivateData.selectedAsset = {};
            break;

          case 'external':
            item._PrivateData.url = item.widget_attrs.url || '';
            item._PrivateData.text = item.widget_attrs.text || '';
            break;

          case 'external:url':
            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.url = item.widget_attrs.url || '';
            item._PrivateData.uiTitle = item.widget_attrs.title || '';
            break;

          case 'external:mobapp':
            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            item._PrivateData.allApps = $rootScope.currentPlatform && ($rootScope.currentPlatform.name === 'android' || $rootScope.currentPlatform.platform_extid === 'android') ? service._AllAndroidAppValues : service._AlliOSAppValues;

            for (var i = 0; i < service._AllAndroidAppValues.length; i++) {
              var app = _.find(service._AllAndroidAppValues, {id: item.widget_attrs.app_name});
              if (app) {
                item._PrivateData.selectedApp = app;
              } else {
                item._PrivateData.selectedApp = {
                  title: '',
                  id: null
                }
              }
            }
            break;

          case 'asset:collection':

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            item._PrivateData.filters = {
              'Type': [],
              'Categories': []
            };
            if (item.widget_attrs.view) {
              item._PrivateData.filters['Type'] = item.widget_attrs.view.split(',').map(function (view) {
                return _getValues(view, 'view') || {};
              });
            }
            if (item.widget_attrs.category) {
              AssetService.GetCategoryCollection({extids: item.widget_attrs.category.split(',')})
                .then(function (collection) {
                  item._PrivateData.filters['Categories'] = collection.map(function (category) {
                    return {
                      id: category.extid,
                      title: category.title
                    }
                  });
                })
                .catch(function (reason) {
                  item._PrivateData.filters['Categories'] = item.widget_attrs.category
                    .split(',')
                    .map(function (category) {
                      return {
                        id: category,
                        title: category
                      }
                    });
                  $rootScope.debugInfo(reason, 'silent');
                  ToastService.Small({
                    title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                    color: 'amber',
                    icon: 'server-off',
                    blocked: true
                  }, 1000 * 6);
                });
            }

            item._PrivateData.showGenres = _getValues(item.widget_attrs.genres_filter_show_mode, 'genres_filter_show_mode');

            if (item._PrivateData.showGenres) {
              item._PrivateData.showGenres = item._PrivateData.showGenres.id;
            }

            item._PrivateData.sort = _getValues(item.widget_attrs.sort, 'sort');

            if (item._PrivateData.sort) {
              item._PrivateData.sort = item._PrivateData.sort.id;
            }

            break;

          case 'ui:showcase':
            item._PrivateData.isRequeared = true;

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;

          case 'ui:recent':
            item._PrivateData.isRequeared = true;

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;

          case 'ui:favorites':
            item._PrivateData.isRequeared = true;

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;
          case 'ui:search':
            item._PrivateData.isRequeared = true;

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;
          case 'ui:settings':
            item._PrivateData.isRequeared = true;

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;
          case 'ui:back':
            item._PrivateData.isRequeared = true;

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;
          case 'ui:logo':
            item._PrivateData.isRequeared = true;
            item._PrivateData.isLocked = true;

            break;

          case 'nop':
            item._PrivateData.isRequeared = true;

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;

          case 'ui:epg':
            item._PrivateData.isRequeared = true;

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;
          case 'ui:rdvr':
            item._PrivateData.isRequeared = true;

            item._PrivateData.title = item.title;
            item._PrivateData.widget_type = _parseWidgetType(item.widget_type);

            item._PrivateData.uiTitle = item.widget_attrs.title;

            break;
        }

        return item;
      };

      service._ParseTile = function (tile) {
        if (!tile) return;

        tile._PrivateData = {};

        if (!tile.banner) return tile;

        switch (true) {
          case tile.type === 'vod':
            tile._PrivateData.type = 'VOD';
            tile._PrivateData.searchResult = [];

            tile._PrivateData.title = tile.asset_title;
            tile._PrivateData.description = tile.asset_description;
            tile._PrivateData.year = tile.asset_movie_year;
            tile._PrivateData.asset_id = tile.asset_id;
            tile._PrivateData.duration = (tile.asset_movie_duration / 3600).toString().substring(0, 3);

            if (tile.asset_genres) {
              tile._PrivateData.genres = tile.asset_genres.map(function (genre) {
                return genre.title;
              });
            }

            if (tile.asset_country) {
              tile._PrivateData.country = tile.asset_country.title;
            }

            lh.common.resources.getPictureByCategory(tile.asset_tile_resources, 'poster_blueprint')
              .then(function (response) {
                tile._PrivateData.picture = response;
              }, function (reason) {
                tile._PrivateData.picture = '';
              });

            break;
          case tile.type === 'banner' && tile.banner.type === 'widget':
            tile._PrivateData.type = 'BANNER';

            tile.banner = service._ParseWidget(tile.banner);
            break;
          case tile.type === 'banner' && tile.banner.type === 'slider':
            tile._PrivateData.type = 'SLIDER';
            tile.slider = tile.banner;
            tile.slider._PrivateData = {};
            tile.slider._PrivateData.hasNewTile = false;
            tile.slider._PrivateData.delay = tile.slider.slider_delay;
            tile.slider._PrivateData.icon = 'mdi-view-carousel';
            tile.slider.slider_items.forEach(function (item) {
              item.banner = service._ParseWidget(item);
              item._PrivateData.isExpand = true;
              item._PrivateData.isSliderInner = true;
            });

            break;
        }

        if (tile.banner && tile.banner._PrivateData.isLocked) {
          tile._PrivateData.isLocked = true;
        }

        return tile;
      };

      service.GetAvailableTiles = function () {
        var deferred = $q.defer();
        var url = 'collection/banner.widget.descriptor/query';

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.data = 'GET';
            reason.url = url;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetScreens = function (platform_id) {
        var deferred = $q.defer();
        var url = 'collection/showcase.screen/query';

        if (platform_id) url += '/dimension/platform_id/eq/' + platform_id;

        url += '?t=' + Date.now();

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.data = 'GET';
            reason.url = url;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetShowcasesByScreenId = function (screen_id) {
        var deferred = $q.defer();
        var url = 'collection/showcase/query/dimension/screen_id/in/' + screen_id + '?t=' + Date.now();

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.data = 'GET';
            reason.url = url;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.CreateScreen = function (showcase, platform_id) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/create';

        var platform = _.find($rootScope.platforms, {id: platform_id});

        var data = {
          ext_id: (platform ? platform.extid : platform_id) + ':' + showcase.title,
          title: showcase.title,
          platform_id: platform_id
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateScreenVariant = function (showcase, platform_id, screen) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/create';

        var platform = _.find($rootScope.platforms, {id: platform_id});

        var data = {
          ext_id: (platform ? platform.extid : platform_id) + ':' + showcase.title,
          title: showcase.title,
          platform_id: platform_id,
          priority: showcase.priority,
          screen_id: screen.id
        };

        if (showcase.group_id.length) {
          data.group_id = showcase.group_id.join(',');
        } else {
          data.group_id = '0';
        }

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetShowcases = function (platform_id) {
        var deferred = $q.defer();
        var url = 'collection/showcase/query';

        if (platform_id) url += '/dimension/platform_id/eq/' + platform_id;

        url += '?t=' + Date.now();

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.data = 'GET';
            reason.url = url;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetShowcasesById = function (showcase_id) {
        var deferred = $q.defer();
        var url = 'collection/showcase/query/dimension/id/in/' + showcase_id + '?t=' + Date.now();

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.data = 'GET';
            reason.url = url;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetShowcasesByLabel = function (label) {
        var deferred = $q.defer();
        var url = 'collection/showcase/query/dimension/labels/eq/' + label;

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.data = 'GET';
            reason.url = url;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.GetTileByShowcaseId = function (showcase_id) {
        var deferred = $q.defer();
        var url = 'collection/showcase.tile/query/dimension/showcase_id/eq/' + showcase_id + '?t=' + Date.now();

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.data = 'GET';
            reason.url = url;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.UpdateShowcase = function (showcase) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/update';

        var data = {
          showcase_id: showcase.id,
          title: showcase.title,
          priority: showcase.priority
        };

        data.group_id = showcase.group_id.join(',') ? showcase.group_id.join(',') : 0;

        if (showcase._PrivateData.background && showcase._PrivateData.background.banner_id) {
          data.background_banner_id = showcase._PrivateData.background.banner_id;
        }

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.RemoveShowcase = function (showcase) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/remove';

        var data = {
          showcase_id: showcase.id
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.UpdateTilePosition = function (tile) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/tile/update';

        var data = {
          tile_id: tile.id,
          x0: tile.x0,
          x1: tile.x1,
          y0: tile.y0,
          y1: tile.y1
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };


      service.DeleteTile = function (tile) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/tile/remove';

        var data = {
          tile_id: tile.id
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateSliderTile = function (showcase, tile, slider) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/tile/slider/create';

        var data = {
          showcase_id: showcase.id,
          slider_id: slider.id,
          x0: tile.x0,
          x1: tile.x1,
          y0: tile.y0,
          y1: tile.y1
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateWidgetTile = function (showcase, tile, widget) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/tile/widget/create';

        var data = {
          showcase_id: showcase.id,
          widget_id: widget.id,
          x0: tile.x0,
          x1: tile.x1,
          y0: tile.y0,
          y1: tile.y1
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateSlider = function (slider, ids) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/slider/create';

        var data = {
          slider_items: ids.join(','),
          title: slider.title || 'slider_title_' + Date.now()
        };

        if (slider._PrivateData.slider_delay) data._PrivateData.slider_delay = slider.delay;
        if (slider.ext_id) data.ext_id = slider.ext_id;

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.UpdateSlider = function (slider, ids) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/slider/update';

        var data = {
          banner_id: slider.id,
          slider_items: ids.join(',')
        };

        if (slider.title) data.title = slider.title;
        if (slider._PrivateData.slider_delay) data._PrivateData.slider_delay = slider.delay;
        if (slider.ext_id) data.ext_id = slider.ext_id;

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateAssetWidget = function (widget, namespace) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/create';

        var data = {
          widget_type: namespace + '/asset',
          title: widget._PrivateData.title || (widget._PrivateData.asset.title + ':' + Date.now()),
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (widget._PrivateData.text) attributes.text = widget._PrivateData.text;
        if (widget._PrivateData.asset) attributes.asset = widget._PrivateData.asset.extid;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.UpdateAssetWidget = function (widget) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/update';

        var data = {
          banner_id: widget.id,
          title: widget._PrivateData.title || '',
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (widget._PrivateData.text) attributes.text = widget._PrivateData.text;
        if (widget._PrivateData.asset) attributes.asset = widget._PrivateData.asset.extid;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateExternalWidget = function (widget, namespace) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/create';

        var data = {
          widget_type: namespace + '/external',
          title: widget._PrivateData.title || '',
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.text) attributes.text = widget._PrivateData.text;
        if (widget._PrivateData.url) attributes.url = widget._PrivateData.url;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.UpdateExternalWidget = function (widget) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/update';

        var data = {
          banner_id: widget.id,
          title: widget._PrivateData.title || '',
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.text) attributes.text = widget._PrivateData.text;
        if (widget._PrivateData.url) attributes.url = widget._PrivateData.url;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateLogoWidget = function (widget, namespace) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/create';

        var data = {
          title: 'logo' + ':' + namespace + ':' + Date.now(),
          widget_type: namespace + '/logo',
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.UpdateLogoWidget = function (widget) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/update';

        var data = {
          banner_id: widget.id,
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateAssetCollectionWidget = function (widget, namespace) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/create';

        var data = {
          title: widget._PrivateData.uiTitle + ':' + namespace + ':' + Date.now(),
          widget_type: namespace + '/ui/asset/collection',
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (widget._PrivateData.filters['Categories'].length) attributes.category = _.map(widget._PrivateData.filters['Categories'], 'id').join(',');
        if (widget._PrivateData.filters['Type'].length) attributes.view = _.map(widget._PrivateData.filters['Type'], 'id').join(',');
        if (widget._PrivateData.showGenres) attributes.genres_filter_show_mode = widget._PrivateData.showGenres;
        if (widget._PrivateData.sort) attributes.sort = widget._PrivateData.sort;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.UpdateAssetCollectionWidget = function (widget) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/update';

        var data = {
          banner_id: widget.id,
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (widget._PrivateData.filters['Categories'].length) attributes.category = _.map(widget._PrivateData.filters['Categories'], 'id').join(',');
        if (widget._PrivateData.filters['Type'].length) attributes.view = _.map(widget._PrivateData.filters['Type'], 'id').join(',');
        if (widget._PrivateData.showGenres) attributes.genres_filter_show_mode = widget._PrivateData.showGenres;
        if (widget._PrivateData.sort) attributes.sort = widget._PrivateData.sort;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };


      service.UpdateUiWidget = function (widget) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/update';

        var data = {
          banner_id: widget.id,
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (widget.widget_type === 'stockmob/external' && widget._PrivateData.url) attributes.url = widget._PrivateData.url;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateUiWidget = function (widget, namespace, type) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/create';

        var data = {
          title: widget._PrivateData.uiTitle || widget._PrivateData.title + ':' + namespace + ':' + Date.now(),
          widget_type: namespace + '/' + type,
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (type === 'external' && widget._PrivateData.url) attributes.url = widget._PrivateData.url;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };


      service.UpdateExternalWidget = function (widget) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/update';

        var data = {
          banner_id: widget.id,
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (widget._PrivateData.url) attributes.url = widget._PrivateData.url;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateExternalWidget = function (widget, namespace) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/create';

        var data = {
          title: widget._PrivateData.uiTitle || widget._PrivateData.title + ':' + namespace + ':' + Date.now(),
          widget_type: namespace + '/external',
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (widget._PrivateData.url) attributes.url = widget._PrivateData.url;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };


      service.UpdateShowcaseWidget = function (widget) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/update';

        var data = {
          banner_id: widget.id,
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (!_.isEmpty(widget._PrivateData.selectedShowcase)) attributes.showcase = widget._PrivateData.selectedShowcase.id;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateShowcaseWidget = function (widget, namespace) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/create';

        var data = {
          title: widget._PrivateData.uiTitle + ':' + namespace + ':' + Date.now(),
          widget_type: namespace + '/ui/showcase',
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;
        if (!_.isEmpty(widget._PrivateData.selectedShowcase)) attributes.showcase = widget._PrivateData.selectedShowcase.id;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.UpdateExternalAppWidget = function (widget) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/update';

        var data = {
          banner_id: widget.id,
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.selectedApp.id) attributes.app_name = widget._PrivateData.selectedApp.id;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateExternalAppWidget = function (widget, namespace) {
        var deferred = $q.defer();
        var url = 'banner/mgmt/widget/create';

        var data = {
          title: widget._PrivateData.uiTitle + ':' + namespace + ':' + Date.now(),
          widget_type: namespace + '/external/app',
          widget_attrs: ''
        };

        var attributes = {};

        if (widget._PrivateData.picture !== widget._PrivateData.originPicture) data.picture_url = widget._PrivateData.picture;
        if (widget._PrivateData.selectedApp.id) attributes.app_name = widget._PrivateData.selectedApp.id;
        if (widget._PrivateData.uiTitle) attributes.title = widget._PrivateData.uiTitle;

        data.widget_attrs = JSON.stringify(attributes);

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.SetShowcaseLabels = function (showcase) {
        var deferred = $q.defer();
        var url = 'showcase/mgmt/label/set';

        var data = {
          showcase_id: showcase.id,
          labels: showcase.extid
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      return service;
    }]);
